const portfolioData = [
  {
    id: 1,
    slug: "ecommerce-platform",
    title: "E-Commerce Platform",
    category: "Web",
    client: "ShopEasy India",
    date: "March 2024",
    technologies: ["React.js", "Node.js", "MongoDB", "Stripe", "Razorpay"],
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1200&h=500&fit=crop",
    desc: "Full-featured online store with payment integration, inventory management, and real-time order tracking.",
    fullDescription: "We built a comprehensive e-commerce platform for ShopEasy India that handles over 10,000 products and processes hundreds of orders daily. The platform features a modern, mobile-responsive design with advanced product filtering, wishlist functionality, real-time inventory tracking, and seamless checkout experience. Integrated with both Stripe and Razorpay for domestic and international payments.",
    features: [
      "Advanced product search & filtering",
      "Real-time inventory management",
      "Multi-payment gateway integration (Stripe + Razorpay)",
      "Order tracking with email/SMS notifications",
      "Admin dashboard with analytics",
      "SEO optimized product pages",
      "Mobile responsive design",
      "Customer review & rating system"
    ],
    results: [
      { metric: "300%", label: "Increase in online sales" },
      { metric: "50%", label: "Reduction in cart abandonment" },
      { metric: "10,000+", label: "Products managed" },
      { metric: "4.8/5", label: "Customer satisfaction" }
    ],
    liveLink: "https://example-shopeasy.com",
    testimonial: {
      text: "SDtech Solutions transformed our business with this incredible e-commerce platform. Sales increased by 300% within 3 months of launch!",
      author: "Amit Sharma",
      role: "CEO, ShopEasy India"
    }
  },
  {
    id: 2,
    slug: "https://clinic.sdtechsolutionsorg.com/",
    title: "Healthcare Management System",
    category: "Software",
    client: "City Hospital Indore",
    date: "January 2024",
    technologies: ["Python", "Django", "PostgreSQL", "React.js", "AWS"],
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&h=500&fit=crop",
    desc: "Comprehensive hospital management solution covering patient records, appointments, billing, and pharmacy.",
    fullDescription: "We developed a complete Hospital Management System for City Hospital Indore that digitized their entire operations. The system manages patient records, doctor appointments, pharmacy inventory, billing, lab reports, and bed management — all from a single dashboard. The solution reduced paperwork by 90% and improved patient handling efficiency significantly.",
    features: [
      "Patient registration & medical records",
      "Doctor appointment scheduling",
      "Pharmacy inventory management",
      "Billing & insurance processing",
      "Lab report management",
      "Bed availability tracking",
      "Role-based access control",
      "Automated report generation"
    ],
    results: [
      { metric: "90%", label: "Reduction in paperwork" },
      { metric: "60%", label: "Faster patient processing" },
      { metric: "500+", label: "Daily patient records" },
      { metric: "99.9%", label: "System uptime" }
    ],
    liveLink: "https://clinic.sdtechsolutionsorg.com/",
    testimonial: {
      text: "The HMS has completely transformed how we manage our hospital. Patient processing is 60% faster and our staff loves the intuitive interface.",
      author: "Dr. Priya Verma",
      role: "Director, City Hospital"
    }
  },
  {
    id: 3,
    slug: "restaurant.sdtechsolutionsorg.com/",
    title: "Restaurant Booking App",
    category: "Mobile",
    client: "FoodieHub Restaurants",
    date: "November 2023",
    technologies: ["Flutter", "Firebase", "Node.js", "Google Maps API"],
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200&h=500&fit=crop",
    desc: "Cross-platform mobile application for table reservations, menu browsing, and online ordering.",
    fullDescription: "A feature-rich restaurant booking application built with Flutter for FoodieHub Restaurants chain. The app allows customers to browse menus, reserve tables, place online orders, and make payments — all from their smartphones. The restaurant dashboard enables real-time order management, table availability tracking, and customer analytics.",
    features: [
      "Table reservation with real-time availability",
      "Digital menu with photos & prices",
      "Online ordering & delivery tracking",
      "In-app payments (UPI, cards, wallets)",
      "Push notifications for offers",
      "Customer loyalty program",
      "Restaurant analytics dashboard",
      "Multi-location support"
    ],
    results: [
      { metric: "40%", label: "Increase in table bookings" },
      { metric: "25%", label: "Revenue growth" },
      { metric: "5,000+", label: "Active users" },
      { metric: "4.7/5", label: "App store rating" }
    ],
    liveLink: "restaurant.sdtechsolutionsorg.com/",
    testimonial: {
      text: "Our booking app built by SDtech Solutions has been a game-changer. Table bookings increased by 40% and our customers love the seamless experience.",
      author: "Rohit Gupta",
      role: "Founder, FoodieHub"
    }
  },
  {
    id: 4,
    slug: "real-estate-portal",
    title: "Real Estate Portal",
    category: "Web",
    client: "HomeFind Realty",
    date: "September 2023",
    technologies: ["Next.js", "Tailwind CSS", "Node.js", "MongoDB", "Google Maps"],
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=500&fit=crop",
    desc: "Property listing platform with advanced search, virtual tours, and agent management dashboard.",
    fullDescription: "A modern real estate portal built with Next.js for HomeFind Realty. The platform features advanced property search with filters for location, price, type, and amenities. Agents have dedicated dashboards to manage listings, track leads, and schedule property visits. The platform includes virtual tour integration and mortgage calculator for enhanced user experience.",
    features: [
      "Advanced property search & filters",
      "Virtual tour integration",
      "Agent dashboard & lead management",
      "Mortgage calculator",
      "Map-based property browsing",
      "Property comparison tool",
      "Email alerts for new listings",
      "SEO optimized listing pages"
    ],
    results: [
      { metric: "200%", label: "Increase in property inquiries" },
      { metric: "1,500+", label: "Active listings" },
      { metric: "50+", label: "Registered agents" },
      { metric: "35%", label: "Conversion rate" }
    ],
    liveLink: "https://example-homefind.com",
    testimonial: {
      text: "The real estate portal SDtech built for us has transformed our business. Property inquiries increased by 200% and our agents love the management dashboard.",
      author: "Sneha Patel",
      role: "Director, HomeFind Realty"
    }
  },
  {
    id: 5,
    slug: "https://class.sdtechsolutionsorg.com/",
    title: "Institute Management System",
    category: "Software",
    client: "EduLearn Academy",
    date: "July 2023",
    technologies: ["React.js", "Node.js", "MongoDB", "WebRTC", "AWS S3"],
    image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=1200&h=500&fit=crop",
    desc: "Online education platform with live classes, course management, progress tracking, and certification.",
    fullDescription: "A comprehensive Learning Management System built for EduLearn Academy that enables online education at scale. The platform supports live video classes, recorded courses, quizzes, assignments, progress tracking, and automated certification. Teachers can create courses, schedule live sessions, and track student performance through detailed analytics.",
    features: [
      "Live video classes with screen sharing",
      "Pre-recorded course management",
      "Quiz & assignment system",
      "Progress tracking & analytics",
      "Automated certificate generation",
      "Discussion forums",
      "Payment gateway for course purchases",
      "Multi-language support"
    ],
    results: [
      { metric: "10,000+", label: "Active students" },
      { metric: "500+", label: "Courses available" },
      { metric: "85%", label: "Course completion rate" },
      { metric: "4.9/5", label: "Student satisfaction" }
    ],
    liveLink: "https://class.sdtechsolutionsorg.com/",
    testimonial: {
      text: "SDtech Solutions built an incredible LMS that has enabled us to reach 10,000+ students. The platform is robust, scalable, and our students love the experience.",
      author: "Dr. Anil Kumar",
      role: "Founder, EduLearn Academy"
    }
  },
  {
    id: 6,
    slug: "https://gym.sdtechsolutionsorg.com/",
    title: "Fitness Tracking App",
    category: "Mobile",
    client: "FitLife Wellness",
    date: "May 2023",
    technologies: ["React Native", "Firebase", "Node.js", "HealthKit API", "Google Fit"],
    image: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1200&h=500&fit=crop",
    desc: "Health and fitness application with workout plans, nutrition tracking, and wearable device integration.",
    fullDescription: "A feature-packed fitness tracking application built with React Native for FitLife Wellness. The app integrates with Apple HealthKit and Google Fit to sync data from wearable devices. Users can follow personalized workout plans, track nutrition, monitor progress, and connect with fitness coaches. The social features allow users to share achievements and participate in challenges.",
    features: [
      "Personalized workout plans",
      "Nutrition & calorie tracking",
      "Wearable device integration (Apple Watch, Fitbit)",
      "Progress photos & body measurements",
      "Social challenges & leaderboards",
      "In-app chat with fitness coaches",
      "Water intake & sleep tracking",
      "Weekly progress reports"
    ],
    results: [
      { metric: "15,000+", label: "Downloads" },
      { metric: "70%", label: "User retention rate" },
      { metric: "4.8/5", label: "App store rating" },
      { metric: "30%", label: "Revenue from premium" }
    ],
    liveLink: "https://gym.sdtechsolutionsorg.com/",
    testimonial: {
      text: "The fitness app SDtech built is incredible. 15,000 downloads in the first month and a 70% retention rate. Their team truly understood our vision.",
      author: "Vikram Singh",
      role: "CEO, FitLife Wellness"
    }
  },
    {
    id: 11,
    slug: "bakery-sweet-shop-franchise-system",
    title: "Bakery & Sweet Shop Franchise Management",
    category: "Food & Restaurant",
    client: "MithaiMax Delights",
    date: "April 2024",
    technologies: ["React.js", "Node.js", "MongoDB", "IoT Sensors", "Razorpay"],
    image: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=1200&h=500&fit=crop",
    desc: "Multi-outlet recipe costing, cold-chain monitoring, franchise royalty tracking & online ordering.",
    fullDescription: "A centralized franchise management platform for MithaiMax covering 200+ outlets. The system tracks recipe-level inventory, monitors cold storage via IoT sensors, automates franchise royalty calculations, and syncs online orders with in-store POS. Reduced ingredient waste by 35% and standardized quality across all locations.",
    features: [
      "Recipe-level inventory & costing",
      "IoT cold-chain temperature alerts",
      "Franchise royalty & payout automation",
      "Online ordering with outlet routing",
      "GST-compliant multi-branch billing",
      "Quality control & audit checklists"
    ],
    results: [
      { metric: "35%", label: "Reduction in ingredient waste" },
      { metric: "200+", label: "Outlets managed" },
      { metric: "99%", label: "Billing accuracy" },
      { metric: "4.7/5", label: "Franchisee satisfaction" }
    ],
    liveLink: "https://example-mithaimax.com",
    testimonial: {
      text: "Managing 200+ outlets used to be chaotic. Now inventory, royalties, and quality are fully automated. SDtech built exactly what the F&B franchise industry needed.",
      author: "Vikram Sethi",
      role: "Founder, MithaiMax Delights"
    }
  },
  {
    id: 12,
    slug: "https://class.sdtechsolutionsorg.com/",
    title: "Skill Development & Vocational Training Portal",
    category: "Education",
    client: "NextGen Skills Foundation",
    date: "March 2024",
    technologies: ["Next.js", "PostgreSQL", "WebRTC", "AWS", "Stripe"],
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1200&h=500&fit=crop",
    desc: "Govt scheme integration, practical assessments, placement tracking & digital certification.",
    fullDescription: "A government-compliant skill development platform managing 15,000+ trainees across 50 centers. Features include scheme-wise enrollment, practical video assessments, industry placement tracking, trainer verification, offline mobile sync for rural areas, and automated NSDC-aligned certification.",
    features: [
      "Government scheme & subsidy tracking",
      "Practical video assessments & rubrics",
      "Industry placement & employer portal",
      "Trainer verification & attendance",
      "Offline-first mobile app for rural centers",
      "Automated digital certificates & QR verification"
    ],
    results: [
      { metric: "15,000+", label: "Trainees enrolled" },
      { metric: "78%", label: "Placement success rate" },
      { metric: "60%", label: "Admin time saved" },
      { metric: "4.8/5", label: "Partner rating" }
    ],
    liveLink: "https://class.sdtechsolutionsorg.com/",
    testimonial: {
      text: "SDtech delivered a robust, offline-capable platform that perfectly aligns with NSDC standards. Our placement tracking is now 100% transparent and auditable.",
      author: "Dr. Meera Iyer",
      role: "Director, NextGen Skills Foundation"
    }
  },
  {
    id: 13,
    slug: "pathology-diagnostic-network-manager",
    title: "Pathology Lab & Diagnostic Network Manager",
    category: "Healthcare",
    client: "QuickTest Diagnostics",
    date: "February 2024",
    technologies: ["Django", "React.js", "PostgreSQL", "HL7 FHIR", "AWS"],
    image: "https://images.unsplash.com/photo-1579154204601-01588f351e67?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1579154204601-01588f351e67?w=1200&h=500&fit=crop",
    desc: "Sample barcode tracking, machine integration, automated reports, home collection & TPA billing.",
    fullDescription: "A HIPAA-compliant LIMS for QuickTest's network of 100+ collection centers. The system tracks samples via barcodes, integrates directly with analyzers, auto-generates reports, optimizes home collection routes, manages TPA insurance billing, and provides a secure doctor portal for result access.",
    features: [
      "Barcode sample tracking & chain of custody",
      "Direct analyzer machine integration",
      "Automated report generation & SMS/Email",
      "Home collection route optimization",
      "TPA insurance & corporate billing",
      "Secure doctor & patient portals"
    ],
    results: [
      { metric: "50%", label: "Faster report delivery" },
      { metric: "100+", label: "Collection centers" },
      { metric: "99.9%", label: "Report accuracy" },
      { metric: "4.9/5", label: "Doctor satisfaction" }
    ],
    liveLink: "https://example-quicktest.com",
    testimonial: {
      text: "Report turnaround time dropped by half and machine integration eliminated manual errors. SDtech understands diagnostic workflows better than any vendor we've worked with.",
      author: "Dr. Sanjay Rao",
      role: "CEO, QuickTest Diagnostics"
    }
  },
  {
    id: 14,
    slug: "jewelry-showroom-pos-inventory",
    title: "Jewelry Showroom POS & Inventory System",
    category: "Retail & Shopping",
    client: "RoyalGems Jewellers",
    date: "January 2024",
    technologies: ["Electron", "React.js", "Node.js", "MySQL", "RFID API"],
    image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=1200&h=500&fit=crop",
    desc: "Karat/purity tracking, making charge calculator, repair jobs, GST compliance & multi-branch sync.",
    fullDescription: "A specialized POS & inventory system built for RoyalGems' 12 showrooms. Handles gold/silver/diamond tracking with karat & purity levels, automated making charge calculations, repair job workflow, customer wishlist & reminders, GST-compliant invoicing, and real-time multi-branch stock synchronization.",
    features: [
      "Karat, purity & weight tracking",
      "Dynamic making charge & wastage calculator",
      "Repair job tracking & customer alerts",
      "Customer wishlist & anniversary reminders",
      "GST-compliant invoicing & HSN mapping",
      "Multi-branch stock transfer & audit"
    ],
    results: [
      { metric: "40%", label: "Faster billing process" },
      { metric: "25%", label: "Reduction in stock shrinkage" },
      { metric: "50,000+", label: "SKUs managed" },
      { metric: "4.8/5", label: "Staff adoption rate" }
    ],
    liveLink: "https://example-royalgems.com",
    testimonial: {
      text: "Jewelry inventory is complex, but SDtech nailed it. Karat tracking, repair jobs, and multi-branch sync work flawlessly. Our billing is 40% faster and audits are stress-free.",
      author: "Anil Mehta",
      role: "Managing Partner, RoyalGems Jewellers"
    }
  },
  {
    id: 15,
    slug: "interior-design-renovation-crm",
    title: "Interior Design & Home Renovation CRM",
    category: "Real Estate & Construction",
    client: "DreamSpace Interiors",
    date: "December 2023",
    technologies: ["Vue.js", "Laravel", "PostgreSQL", "AWS S3", "Stripe"],
    image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1200&h=500&fit=crop",
    desc: "3D design approvals, material procurement, contractor scheduling, milestone payments & client dashboard.",
    fullDescription: "A project management CRM tailored for DreamSpace Interiors handling 200+ annual projects. Features include 3D design approval workflows, material procurement tracking, contractor scheduling, milestone-based payment collection, client progress dashboard, and post-handover warranty management.",
    features: [
      "3D design versioning & client approval",
      "Material BOQ & procurement tracking",
      "Contractor scheduling & task assignment",
      "Milestone payment & invoice automation",
      "Client progress dashboard & chat",
      "Warranty & AMC management portal"
    ],
    results: [
      { metric: "30%", label: "Reduction in project delays" },
      { metric: "85%", label: "First-time design approval" },
      { metric: "200+", label: "Projects delivered/year" },
      { metric: "4.7/5", label: "Client satisfaction" }
    ],
    liveLink: "https://example-dreamspace.com",
    testimonial: {
      text: "From design approval to final handover, everything is now transparent. Clients love the progress dashboard and our project delays dropped by 30%. Excellent work!",
      author: "Neha Kapoor",
      role: "Founder, DreamSpace Interiors"
    }
  },
  {
    id: 16,
    slug: "ca-firm-accounting-practice-manager",
    title: "CA Firm & Accounting Practice Manager",
    category: "Corporate & HR",
    client: "FinTrust Advisors",
    date: "November 2023",
    technologies: ["React.js", ".NET Core", "SQL Server", "Tally API", "AWS"],
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&h=500&fit=crop",
    desc: "Client document vault, ITR/GST filing tracker, task assignment, deadline alerts & retainer billing.",
    fullDescription: "A practice management platform built for FinTrust Advisors managing 500+ clients. Features include secure document vault, ITR/GST/TDS filing tracker, team task assignment, automated deadline alerts, retainer billing, audit checklists, and Tally/QuickBooks sync. Reduced compliance delays by 60%.",
    features: [
      "Secure client document vault & e-sign",
      "ITR, GST, TDS filing status tracker",
      "Team task assignment & workload view",
      "Automated deadline & penalty alerts",
      "Retainer billing & payment reminders",
      "Audit checklists & compliance reports"
    ],
    results: [
      { metric: "60%", label: "Faster compliance filing" },
      { metric: "500+", label: "Clients managed" },
      { metric: "95%", label: "On-time delivery rate" },
      { metric: "4.9/5", rating: "Client retention" }
    ],
    liveLink: "https://example-fintrust.com",
    testimonial: {
      text: "Missed deadlines are now a thing of the past. The filing tracker and automated alerts keep our team proactive. SDtech built a CA's dream practice management tool.",
      author: "CA Rajesh Gupta",
      role: "Managing Partner, FinTrust Advisors"
    }
  },
  {
    id: 17,
    slug: "cab-fleet-rental-management",
    title: "Cab Fleet & Vehicle Rental Platform",
    category: "Travel & Hospitality",
    client: "CityRide Motors",
    date: "October 2023",
    technologies: ["Flutter", "Firebase", "Node.js", "Google Maps", "Razorpay"],
    image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1200&h=500&fit=crop",
    desc: "Real-time tracking, driver KYC, maintenance scheduling, dynamic pricing & revenue analytics.",
    fullDescription: "A complete fleet management solution for CityRide's 1,200+ vehicles. Includes real-time GPS tracking, driver app with KYC & earnings, preventive maintenance scheduling, dynamic pricing engine, corporate booking portal, and revenue analytics. Improved fleet utilization by 45%.",
    features: [
      "Real-time GPS tracking & geofencing",
      "Driver app with KYC & payout tracking",
      "Preventive maintenance & service alerts",
      "Dynamic pricing & surge management",
      "Corporate booking & invoice portal",
      "Revenue, utilization & idle-time analytics"
    ],
    results: [
      { metric: "45%", label: "Increase in fleet utilization" },
      { metric: "30%", label: "Reduction in maintenance costs" },
      { metric: "1,200+", label: "Vehicles managed" },
      { metric: "4.6/5", label: "Driver satisfaction" }
    ],
    liveLink: "https://example-cityride.com",
    testimonial: {
      text: "Our fleet utilization jumped by 45% and maintenance costs dropped significantly. The driver app and corporate portal are game-changers. SDtech delivered beyond expectations.",
      author: "Karan Malhotra",
      role: "CEO, CityRide Motors"
    }
  },
  {
    id: 18,
    slug: "warehouse-3pl-logistics-system",
    title: "Warehouse & 3PL Logistics Management System",
    category: "Manufacturing & Industrial",
    client: "SwiftStore Logistics",
    date: "September 2023",
    technologies: ["Angular", "Java Spring Boot", "PostgreSQL", "MQTT", "Power BI"],
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1200&h=500&fit=crop",
    desc: "Bin/location tracking, barcode/RFID scanning, pick/pack/ship workflow, carrier sync & client portal.",
    fullDescription: "A high-throughput WMS for SwiftStore's 3PL operations handling 50,000+ daily shipments. Features bin-level inventory tracking, barcode/RFID scanning, optimized pick/pack/ship workflows, multi-carrier integration, returns management, and a white-label client portal for real-time stock visibility.",
    features: [
      "Bin/location-level inventory tracking",
      "Barcode & RFID scanning workflows",
      "Optimized pick, pack & ship routing",
      "Multi-carrier rate shopping & label gen",
      "Returns (RMA) & quality inspection",
      "White-label client portal & API access"
    ],
    results: [
      { metric: "35%", label: "Faster order fulfillment" },
      { metric: "99.5%", label: "Inventory accuracy" },
      { metric: "50,000+", label: "Daily shipments processed" },
      { metric: "4.8/5", label: "Client retention" }
    ],
    liveLink: "https://example-swiftstore.com",
    testimonial: {
      text: "Our fulfillment speed increased by 35% and inventory accuracy is near perfect. The client portal reduced support tickets by half. SDtech built enterprise-grade logistics software.",
      author: "Vijay Nair",
      role: "COO, SwiftStore Logistics"
    }
  },
  {
    id: 19,
    slug: "event-wedding-planning-suite",
    title: "Event & Wedding Planning Management Suite",
    category: "Digital & Creative",
    client: "CelebratePro Events",
    date: "August 2023",
    technologies: ["React.js", "Supabase", "Node.js", "Stripe", "Cloudinary"],
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1519741497674-611481863552?w=1200&h=500&fit=crop",
    desc: "Vendor marketplace, budget tracker, guest RSVP, timeline scheduler, payment milestones & media gallery.",
    fullDescription: "An end-to-end event management platform for CelebratePro handling 300+ weddings & corporate events annually. Features include vendor marketplace with contracts, budget vs actual tracking, guest RSVP & seating planner, day-of timeline scheduler, milestone payments, and secure photo/video gallery delivery.",
    features: [
      "Vendor marketplace & contract management",
      "Budget tracker & expense categorization",
      "Guest RSVP, dietary preferences & seating",
      "Day-of timeline & staff assignment",
      "Milestone payments & vendor payouts",
      "Secure photo/video gallery & downloads"
    ],
    results: [
      { metric: "50%", label: "Planning time saved" },
      { metric: "300+", label: "Events managed/year" },
      { metric: "98%", label: "Vendor on-time delivery" },
      { metric: "4.9/5", label: "Client rating" }
    ],
    liveLink: "https://example-celebratepro.com",
    testimonial: {
      text: "From vendor booking to guest seating, everything is now organized in one place. Our clients are thrilled with the transparency and our team saves hours every week.",
      author: "Pooja Sharma",
      role: "Founder, CelebratePro Events"
    }
  },
  {
    id: 20,
    slug: "https://clinic.sdtechsolutionsorg.com/",
    title: "Skin Clinic & Aesthetic Treatment CRM",
    category: "Fitness & Beauty",
    client: "GlowDerma Clinics",
    date: "July 2023",
    technologies: ["Next.js", "PostgreSQL", "Node.js", "AWS", "Razorpay"],
    image: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=1200&h=500&fit=crop",
    desc: "Patient skin records, treatment plans, appointment reminders, package billing & before/after gallery.",
    fullDescription: "A specialized CRM for GlowDerma's 8 aesthetic clinics. Manages patient skin analysis records, custom treatment plans, automated appointment reminders, package & session billing, secure before/after photo gallery, doctor clinical notes, and membership loyalty programs. Reduced no-shows by 25%.",
    features: [
      "Digital skin analysis & progress tracking",
      "Custom treatment plans & session logging",
      "Automated SMS/WhatsApp appointment reminders",
      "Package billing & session deduction",
      "Secure before/after photo gallery",
      "Doctor notes & prescription templates"
    ],
    results: [
      { metric: "40%", label: "Increase in repeat visits" },
      { metric: "25%", label: "Reduction in no-shows" },
      { metric: "15,000+", label: "Patients managed" },
      { metric: "4.8/5", label: "Patient satisfaction" }
    ],
    liveLink: "https://clinic.sdtechsolutionsorg.com/",
    testimonial: {
      text: "Our patient retention improved dramatically and no-shows dropped by 25%. The treatment tracking and photo gallery are exactly what aesthetic clinics need. Brilliant work!",
      author: "Dr. Ananya Desai",
      role: "Medical Director, GlowDerma Clinics"
    }
  },
  {
    id: 21,
    slug: "https://clinic.sdtechsolutionsorg.com/",
    title: "Dental Clinic & Orthodontic Management System",
    category: "Healthcare",
    client: "SmileCraft Dental Chain",
    date: "June 2024",
    technologies: ["React.js", "Node.js", "PostgreSQL", "DICOM Viewer", "AWS"],
    image: "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=1200&h=500&fit=crop",
    desc: "Digital X-ray integration, treatment planning, appointment recalls, insurance claims & consumables tracking.",
    fullDescription: "A specialized dental practice management platform for SmileCraft's 50+ clinics. The system integrates with intraoral cameras & OPG machines, manages multi-visit treatment plans, automates patient recalls, tracks dental consumables, processes TPA insurance, and provides a secure patient portal for progress tracking.",
    features: [
      "Digital X-ray & intraoral image integration",
      "Multi-visit treatment planning & charting",
      "Automated recall & preventive care reminders",
      "TPA insurance & cashless claim processing",
      "Dental consumables & sterilization tracking",
      "Patient portal with progress & payment history"
    ],
    results: [
      { metric: "35%", label: "Faster patient checkout" },
      { metric: "90%", label: "Patient recall rate" },
      { metric: "50+", label: "Clinics managed" },
      { metric: "4.8/5", label: "Dentist satisfaction" }
    ],
    liveLink: "https://clinic.sdtechsolutionsorg.com/",
    testimonial: {
      text: "From X-rays to insurance claims, everything is now digital and seamless. Patient recalls improved dramatically and our dentists love the intuitive treatment planner.",
      author: "Dr. Kavita Menon",
      role: "Clinical Director, SmileCraft Dental"
    }
  },
  {
    id: 22,
    slug: "https://class.sdtechsolutionsorg.com/",
    title: "School & College Admission + ERP Portal",
    category: "Education",
    client: "GreenValley Public School",
    date: "May 2024",
    technologies: ["Next.js", "MongoDB", "Razorpay", "Firebase", "AWS"],
     image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=600&h=400&fit=crop",
  bannerImage: "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1200&h=500&fit=crop",
    desc: "Online admissions, fee management, timetable generator, exam portal, parent app & transport tracking.",
    fullDescription: "A complete digital campus solution for GreenValley Group managing 15,000+ students. Covers online admission workflows, automated fee collection with reminders, dynamic timetable generation, CCE exam & report cards, GPS-enabled transport tracking, and a dedicated parent mobile app for real-time updates.",
    features: [
      "End-to-end online admission workflow",
      "Automated fee collection & penalty rules",
      "AI-assisted timetable & room allocation",
      "CCE exam pattern & digital report cards",
      "GPS bus tracking & attendance sync",
      "Parent app with homework & progress alerts"
    ],
    results: [
      { metric: "70%", label: "Paperless admissions" },
      { metric: "15,000+", label: "Students managed" },
      { metric: "95%", label: "On-time fee collection" },
      { metric: "4.7/5", label: "Parent satisfaction" }
    ],
    liveLink: "https://class.sdtechsolutionsorg.com/",
    testimonial: {
      text: "Admissions to report cards, everything is now automated. Parents love the real-time updates and our admin team saves hours every day. SDtech delivered a flawless ERP.",
      author: "Principal R. Sharma",
      role: "Director, GreenValley Public School"
    }
  },
  {
    id: 23,
    slug: "furniture-decor-ecommerce-ar",
    title: "Furniture & Home Decor E-commerce with AR",
    category: "Retail & Shopping",
    client: "WoodNest Interiors",
    date: "April 2024",
    technologies: ["React Native", "Three.js", "Node.js", "PostgreSQL", "Stripe"],
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=1200&h=500&fit=crop",
    desc: "3D/AR room preview, custom configuration, delivery scheduling, installer tracking & B2B trade portal.",
    fullDescription: "A premium furniture e-commerce platform built for WoodNest with augmented reality room preview. Customers can visualize products in their space, customize fabrics/finishes, schedule white-glove delivery, track installers, and access a dedicated B2B trade portal for architects & interior designers.",
    features: [
      "WebAR room preview & 360° product views",
      "Fabric, finish & dimension customization",
      "Slot-based delivery & installation scheduling",
      "Real-time installer tracking & e-POD",
      "B2B trade portal with wholesale pricing",
      "Wishlist, mood boards & design consultation"
    ],
    results: [
      { metric: "45%", label: "Higher conversion rate" },
      { metric: "30%", label: "Reduction in returns" },
      { metric: "8,000+", label: "Monthly orders" },
      { metric: "4.6/5", label: "Customer rating" }
    ],
    liveLink: "https://example-woodnest.com",
    testimonial: {
      text: "The AR preview alone boosted our conversions by 45%. Delivery scheduling and B2B portal work flawlessly. SDtech truly understands premium retail tech.",
      author: "Arjun Mehta",
      role: "Founder, WoodNest Interiors"
    }
  },
  {
    id: 24,
    slug: "smart-home-iot-service-crm",
    title: "Smart Home Installation & IoT Service CRM",
    category: "Real Estate & Construction",
    client: "NexaSmart Living",
    date: "March 2024",
    technologies: ["Vue.js", "Laravel", "MQTT", "PostgreSQL", "AWS IoT"],
    image: "https://images.unsplash.com/photo-1519222970733-f546218fa6d7?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  bannerImage: "https://images.unsplash.com/photo-1519222970733-f546218fa6d7?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    desc: "Site survey scheduling, device inventory, installer app, warranty/AMC tracking & client dashboard.",
    fullDescription: "A field service CRM built for NexaSmart's smart home installation business. Manages site surveys, device inventory, technician routing, digital checklists, warranty & AMC contracts, and a client dashboard for device status & support tickets. Improved first-time fix rate to 98%.",
    features: [
      "Site survey & quotation workflow",
      "Device serial tracking & inventory sync",
      "Installer mobile app with offline checklists",
      "Warranty, AMC & renewal automation",
      "Client dashboard & support ticketing",
      "Automated maintenance & filter alerts"
    ],
    results: [
      { metric: "40%", label: "Faster installations" },
      { metric: "98%", label: "First-time fix rate" },
      { metric: "500+", label: "Projects delivered" },
      { metric: "4.9/5", label: "Client satisfaction" }
    ],
    liveLink: "https://example-nexasmart.com",
    testimonial: {
      text: "Our technicians are 40% more productive and clients love the transparent dashboard. SDtech built a CRM that perfectly matches IoT service workflows.",
      author: "Vikram Joshi",
      role: "CEO, NexaSmart Living"
    }
  },
  {
    id: 25,
    slug: "recruitment-staffing-ats",
    title: "Recruitment & Staffing Agency ATS",
    category: "Corporate & HR",
    client: "TalentBridge Staffing",
    date: "February 2024",
    technologies: ["React.js", ".NET Core", "SQL Server", "Elasticsearch", "Azure"],
    image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=1200&h=500&fit=crop",
    desc: "Resume parsing, AI candidate matching, interview scheduling, client job portal & compliance tracking.",
    fullDescription: "An enterprise ATS built for TalentBridge managing 10,000+ candidates. Features AI-powered resume parsing, skill-based matching, automated interview scheduling, client job requisition portal, timesheet & payroll sync, and statutory compliance tracking. Reduced time-to-hire by 60%.",
    features: [
      "AI resume parsing & skill extraction",
      "Smart candidate-job matching engine",
      "Automated interview scheduling & reminders",
      "Client requisition & approval portal",
      "Timesheet, billing & payroll integration",
      "PF/ESI/contract compliance tracking"
    ],
    results: [
      { metric: "60%", label: "Faster time-to-hire" },
      { metric: "10,000+", label: "Candidates managed" },
      { metric: "85%", label: "Placement success rate" },
      { metric: "4.8/5", label: "Agency rating" }
    ],
    liveLink: "https://example-talentbridge.com",
    testimonial: {
      text: "Our recruiters close positions 60% faster and clients love the transparent job portal. SDtech delivered an ATS that actually works for Indian staffing workflows.",
      author: "Neha Kapoor",
      role: "Director, TalentBridge Staffing"
    }
  },
  {
    id: 26,
    slug: "auto-showroom-service-crm",
    title: "Automobile Showroom & Service Center CRM",
    category: "Manufacturing & Industrial",
    client: "AutoPrime Motors",
    date: "January 2024",
    technologies: ["Angular", "Java Spring Boot", "MySQL", "Firebase", "Razorpay"],
    image: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=1200&h=500&fit=crop",
    desc: "Lead management, test drive scheduling, service job cards, spare parts inventory & warranty claims.",
    fullDescription: "A unified dealership CRM for AutoPrime's 12 showrooms & service centers. Manages sales leads, test drive bookings, digital job cards, technician allocation, spare parts inventory, warranty claim processing, and a customer app for service tracking & loyalty rewards.",
    features: [
      "Lead scoring & follow-up automation",
      "Test drive scheduling & feedback capture",
      "Digital job cards & technician routing",
      "Spare parts inventory & reorder alerts",
      "Warranty claim & approval workflow",
      "Customer app with service tracking & rewards"
    ],
    results: [
      { metric: "35%", label: "More test drive conversions" },
      { metric: "25%", label: "Faster service turnaround" },
      { metric: "12", label: "Showrooms managed" },
      { metric: "4.7/5", label: "Customer satisfaction" }
    ],
    liveLink: "https://example-autoprime.com",
    testimonial: {
      text: "From sales to service, everything is now connected. Service TAT dropped by 25% and our customers love tracking their vehicle in real-time. Outstanding delivery!",
      author: "Rajesh Verma",
      role: "MD, AutoPrime Motors"
    }
  },
  {
    id: 27,
    slug: "influencer-creator-marketplace",
    title: "Influencer Marketing & Creator Marketplace",
    category: "Digital & Creative",
    client: "BuzzScale Media",
    date: "December 2023",
    technologies: ["Next.js", "Supabase", "Node.js", "Stripe", "Cloudinary"],
    image: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=1200&h=500&fit=crop",
    desc: "Creator discovery, campaign briefs, content approval, performance analytics & automated payouts.",
    fullDescription: "A scalable influencer marketplace connecting 5,000+ creators with brands. Features AI-based creator discovery, campaign brief management, content approval workflows, real-time performance analytics (reach, engagement, ROI), automated escrow payouts, and brand collaboration dashboards.",
    features: [
      "AI creator discovery & audience insights",
      "Campaign briefs & proposal management",
      "Content review, revision & approval flow",
      "Real-time ROI & engagement analytics",
      "Escrow payments & automated payouts",
      "Brand dashboard & campaign reporting"
    ],
    results: [
      { metric: "3x", label: "Campaign ROI improvement" },
      { metric: "5,000+", label: "Verified creators" },
      { metric: "90%", label: "On-time content delivery" },
      { metric: "4.9/5", label: "Brand satisfaction" }
    ],
    liveLink: "https://example-buzzscale.com",
    testimonial: {
      text: "Our brands see 3x ROI and creators get paid on time, every time. The approval workflow and analytics are best-in-class. SDtech built a true marketplace engine.",
      author: "Simran Roy",
      role: "CEO, BuzzScale Media"
    }
  },
  {
    id: 28,
    slug: "tiffin-corporate-catering-app",
    title: "Tiffin & Corporate Catering Management App",
    category: "Food & Restaurant",
    client: "DailyBite Meals",
    date: "November 2023",
    technologies: ["Flutter", "Firebase", "Node.js", "Google Maps", "Razorpay"],
    image: "https://images.unsplash.com/photo-1543353071-873f17a7a088?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1543353071-873f17a7a088?w=1200&h=500&fit=crop",
    desc: "Subscription plans, meal customization, route optimization, delivery app & corporate billing.",
    fullDescription: "A subscription-based meal delivery platform for DailyBite serving 8,000+ daily meals. Features flexible tiffin plans, dietary customization, AI route optimization for riders, delivery executive app, corporate billing with GST invoices, and automated feedback & rating system.",
    features: [
      "Weekly/monthly subscription management",
      "Dietary preferences & meal customization",
      "AI route optimization & rider allocation",
      "Delivery app with OTP & e-POD",
      "Corporate billing & GST invoicing",
      "Automated feedback & quality alerts"
    ],
    results: [
      { metric: "50%", label: "Delivery time saved" },
      { metric: "8,000+", label: "Daily meals delivered" },
      { metric: "95%", label: "Customer retention" },
      { metric: "4.8/5", label: "App rating" }
    ],
    liveLink: "https://example-dailybite.com",
    testimonial: {
      text: "Route optimization alone cut our delivery time in half. Corporate clients love the billing portal and subscribers never miss a meal. SDtech nailed food logistics!",
      author: "Amit Chauhan",
      role: "Founder, DailyBite Meals"
    }
  },
  {
    id: 29,
    slug: "bus-tour-operator-booking-system",
    title: "Bus & Tour Operator Booking System",
    category: "Travel & Hospitality",
    client: "RoadLink Travels",
    date: "October 2023",
    technologies: ["React.js", "PostgreSQL", "Node.js", "Amadeus API", "Stripe"],
    image: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=1200&h=500&fit=crop",
    desc: "Seat layout booking, dynamic pricing, fleet management, agent portal & GPS tracking.",
    fullDescription: "A complete booking & fleet management system for RoadLink's 300+ routes. Features interactive seat layout booking, dynamic pricing, driver & vehicle management, B2B agent portal, automated cancellation/refund workflows, and real-time GPS tracking for passengers.",
    features: [
      "Interactive seat layout & boarding points",
      "Dynamic pricing & seasonal offers",
      "Fleet, driver & maintenance tracking",
      "B2B agent portal & commission management",
      "Automated refunds & cancellation policies",
      "Live GPS tracking & SMS alerts"
    ],
    results: [
      { metric: "40%", label: "Increase in direct bookings" },
      { metric: "300+", label: "Routes managed" },
      { metric: "99%", label: "System uptime" },
      { metric: "4.6/5", label: "Traveler rating" }
    ],
    liveLink: "https://example-roadlink.com",
    testimonial: {
      text: "Direct bookings jumped by 40% and our agents love the commission portal. GPS tracking reduced support calls by half. SDtech delivered a robust travel platform.",
      author: "Karan Desai",
      role: "Operations Head, RoadLink Travels"
    }
  },
  {
    id: 30,
    slug: "textile-garment-b2b-portal",
    title: "Textile & Garment Wholesale B2B Portal",
    category: "Manufacturing & Industrial",
    client: "FabricHub Exports",
    date: "September 2023",
    technologies: ["Vue.js", "Django", "PostgreSQL", "AWS S3", "Razorpay"],
    image: "https://images.unsplash.com/photo-1558171813-4c088753af8f?w=600&h=400&fit=crop",
    bannerImage: "https://images.unsplash.com/photo-1558171813-4c088753af8f?w=1200&h=500&fit=crop",
    desc: "Catalog management, MOQ pricing, order tracking, credit limits, sample requests & dealer app.",
    fullDescription: "A B2B wholesale portal for FabricHub managing 2,000+ dealers across India. Features digital catalogs, MOQ-based pricing, credit limit management, sample request workflow, order & dispatch tracking, GST invoicing, and a dedicated dealer mobile app for reordering.",
    features: [
      "Digital catalogs with variant mapping",
      "MOQ & tier-based wholesale pricing",
      "Credit limit & payment term management",
      "Sample request & approval workflow",
      "Order tracking & e-way bill generation",
      "Dealer app with quick reorder & statements"
    ],
    results: [
      { metric: "55%", label: "Faster order processing" },
      { metric: "2,000+", label: "Active dealers" },
      { metric: "40%", label: "Increase in repeat orders" },
      { metric: "4.8/5", label: "Dealer satisfaction" }
    ],
    liveLink: "https://example-fabrichub.com",
    testimonial: {
      text: "Our dealers now reorder in seconds and credit management is fully automated. Order processing is 55% faster and disputes have dropped significantly. Excellent work!",
      author: "Suresh Patil",
      role: "Director, FabricHub Exports"
    }
  }
];

export default portfolioData;
